import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {FileManagementService} from '@core/services/file-management.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {Router} from '@angular/router';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScenarioWorkflowHandler implements IPlatformToolHandler {
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  private sourceType: string;

  constructor(private commandService: CommandService,
              private router: Router,
              private fuseSplashScreenService: FuseSplashScreenService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              ) { }


  destroy(): void {
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    command.projectId = '[PROJECT_ID]';
    this.executeCommandToApi(command);

  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  private handleAction($event): boolean {
    if ($event.action) {
      switch ($event.action?.id) {
        case 'Open':
          const command = $event.item.cells['OpenCommand'].value;
          if (command) {
            this.executeCommand(command);
          }
          return true;
        default:
          return true;
      }
    }
    return false;
  }

  private handleByFieldDefinition($event): boolean {
    const command = $event.item.cells['OpenCommand'].value;
    if (command) {
      this.executeCommand(command);
      return true;
    }
    return false;
  }

  private handleCommand($event): boolean {
    if ($event.command) {
      switch ($event.command.name) {
        case 'CommandName':
          return true;
        default:
          this.executeCommand($event.command);
          return true;
      }
    }
    return false;
  }

  valueChanged($event) {
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
    if (this.handleByFieldDefinition($event)) {
      return;
    }
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('[scenario-platform-command] Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommandToApi(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
          }
          if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['SnackBarMessage']);
          }

          if (commandResponse.fieldValues['FileId']) {
            const fileId = commandResponse.fieldValues['FileId'];
            const fileName = commandResponse.fieldValues['FileName'];

            this.downloadFile(fileId, fileName);
          }
          if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModel = commandResponse.fieldValues['PlatformLinkModel'];
            this.magicLinkModelValueChangedHandler({
              id: 'PlatformToolContainerComponent', value: commandResponse.fieldValues['PlatformLinkModel'],
              magicLinkModel: this.magicLinkModel
            });
            return;
          }

          this.invalidateSubject.invalidate();
        },
        error => {
          console.log(error);
          this.fuseSplashScreenService.hide();
        });
    }
  }

  private downloadFile(fileId: string, fileName: string) {
    this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
      this.fileManagementService.openSaveFileWindow(payload, fileName);
      this.fuseSplashScreenService.hide();
    });
  }

  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }

}
